import { AfterViewInit, Component, computed, ElementRef, inject, Injector, OnInit, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonDateTimeField, CommonDateTimeFieldConfig, CommonDateTimeFieldWidget, CommonForm, UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { ReadonlyAccessWidget } from '../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';

@Component({
	selector: 'final-presentation-set-deck-submitted-date-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		ReadonlyAccessWidget,
		CommonButtonRowWidget,
		CommonDateTimeFieldWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './set-deck-submitted-date.dialog.html',
})
export class FinalPresentationSetDeckSubmittedDateDialog implements AfterViewInit {
	public dialog: DialogContext<{ accVentureId: number, deckSubmittedUTC?: number }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<FinalPresentationSetDeckSubmittedDateDialog>);
	public accAreaService = inject(AcceleratorAreaService);
	public util = inject(UtilityService);
	public dialogService = inject(DialogService);

	public dateFormSaveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('dateFormSaveBtn');

	public deckSubmittedUTC = computed(() => this.dialog.data?.deckSubmittedUTC);


	icon = signal('fa-regular fa-calendar');

	public isReadonly = computed(() => !this.accAreaService.canEdit());
	public readonly form = new CommonForm<{ deckSubmittedUTC: number }>(inject(Injector));


	readonly deckSubmittedDate = computed<CommonDateTimeField>(() => ({
		config: signal<CommonDateTimeFieldConfig>({
			label: 'Deck Submitted Date',
			minDateUTC: this.accAreaService.data()?.acc.classesStartWeekUTC,
			isRequired: true, isSpanish: false, type: 'event', includeTime: true,
			isEnabled: computed(() => this.accAreaService.canEdit())
		}),
		actualValue: computed(() => this.dialog.data?.deckSubmittedUTC),
		pendingValue: signal<number | undefined | null>(null),
		saving: signal(false),
		error: signal(''),
		formFieldName: 'deckSubmittedUTC',
		form: this.form,
	}));


	ngAfterViewInit() {
		this.form.setSubmitButton(
			this.dateFormSaveBtn(),
			async (values: { deckSubmittedUTC: number }, changed: string[]) => {
				console.log('Submitting event edit form with values:', values, 'and changed fields:', changed);
				const accVentureId = this.dialog.data?.accVentureId;
				if (values.deckSubmittedUTC && accVentureId) {
					await this.accAreaService.setVentureDeckSubmittedUTC(accVentureId, values.deckSubmittedUTC);
					this.close();

				}
			}
		);
	}

	public close() {
		this.dialogRef.close();
	}

	public async delete() {
		const accVentureId = this.dialog.data?.accVentureId;
		if (this.deckSubmittedUTC() && accVentureId) {
			await this.accAreaService.setVentureDeckSubmittedUTC(accVentureId, undefined);
			this.close();
		}
	}

}
